import {
  ArrayParam,
  BooleanParam,
  createEnumDelimitedArrayParam,
  createEnumParam,
  DateParam,
  JsonParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';

import { BuildingReadModelSort, SortOrder } from '@client/api';

export const useBuildingsSearchQueryParams = () => {
  const result = useQueryParams({
    buildingsSearch: StringParam,
  });

  return result;
};

export const useBuildingsSortQueryParams = () => {
  const result = useQueryParams({
    buildingsSortProperty: withDefault<BuildingReadModelSort | undefined | null, BuildingReadModelSort>(
      createEnumParam(['Name', 'TotalArea', 'Type']),
      'Name',
    ),
    buildingsSortOrder: withDefault<SortOrder | undefined | null, SortOrder>(createEnumParam(['Asc', 'Desc']), 'Asc'),
  });

  return result;
};

export const useBuildingsFilterQueryParams = () => {
  const result = useQueryParams({
    locationFromEnabled: BooleanParam,
    locationFrom: JsonParam,
    locationRadius: NumberParam,
    totalAreaEnabled: BooleanParam,
    totalAreaFrom: NumberParam,
    totalAreaTo: NumberParam,
    availableAreaEnabled: BooleanParam,
    availableAreaFrom: NumberParam,
    availableAreaTo: NumberParam,
    unavailableAreaEnabled: BooleanParam,
    unavailableAreaFrom: NumberParam,
    unavailableAreaTo: NumberParam,
    availableDateEnabled: BooleanParam,
    availableDateFrom: DateParam,
    availableDateTo: DateParam,
    vacantDateEnabled: BooleanParam,
    vacantDateFrom: DateParam,
    vacantDateTo: DateParam,
    constructionYearEnabled: BooleanParam,
    constructionYearFrom: NumberParam,
    constructionYearTo: NumberParam,
    bedroomCountEnabled: BooleanParam,
    bedroomCountFrom: NumberParam,
    bedroomCountTo: NumberParam,
    bathroomCountEnabled: BooleanParam,
    bathroomCountFrom: NumberParam,
    bathroomCountTo: NumberParam,
    standard: createEnumDelimitedArrayParam(['Low', 'Medium', 'High']),
    energyLabel: createEnumDelimitedArrayParam(['A', 'B', 'C', 'D', 'E', 'F', 'G']),
    buildingTypes: createEnumDelimitedArrayParam(['Office', 'RetailHighStreet', 'Retail', 'Logistics', 'Industrial', 'Hotel', 'Healthcare', 'Education', 'Mixed']),
    tags: ArrayParam,
  });

  return result;
};

export const useBuildingsTabQueryParams = () => {
  const result = useQueryParams({
    buildingTypes: createEnumDelimitedArrayParam(['Office', 'RetailHighStreet', 'Retail', 'Logistics', 'Industrial', 'Hotel', 'Healthcare', 'Education', 'Mixed']),
  });

  return result;
};
